import React, { useState } from "react"
import { Modal, Divider, Typography, Button, Space, message } from "antd"
import { doc, updateDoc, serverTimestamp } from "firebase/firestore"
import { db } from "../../firebase/config"
import { useAuthContext } from "../../hooks/useAuthContext"

const { Text } = Typography

export default function StopRequestHandler({ order, isOpen, onClose }) {
  const { user, paperManager, devSpecialist, admin } = useAuthContext()
  const [loading, setLoading] = useState(false)

  const canApprove = paperManager || devSpecialist || admin
  const isOwner = order.uid === user?.uid

  const handleApproveStop = async () => {
    if (!canApprove) return
    setLoading(true)
    const ref = doc(db, "orders", order.id)
    try {
      await updateDoc(ref, {
        orderStatus: 999,
        requestedToStop: false,
        orderStopped: serverTimestamp(),
        stoppedBy: user.email,
      })
      message.success("Order stopped")
      onClose()
    } catch (error) {
      message.error("Error stopping order")
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const handleCancelStop = async () => {
    if (!isOwner) return
    setLoading(true)
    const ref = doc(db, "orders", order.id)
    try {
      await updateDoc(ref, {
        requestedToStop: false,
        stopRequestComment: null,
      })
      message.success("Stop request cancelled")
      onClose()
    } catch (error) {
      message.error("Error cancelling stop request")
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      title="Stop Request"
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={400}>
      <Divider>Stop Request Comment</Divider>
      <Text>{order.stopRequestComment || "No reason provided"}</Text>

      <Divider>Actions</Divider>
      <Space direction="vertical" style={{ width: "100%" }}>
        {canApprove && (
          <Button
            block
            type="primary"
            danger
            onClick={handleApproveStop}
            loading={loading}>
            Approve & Stop Order
          </Button>
        )}
        {isOwner && (
          <Button
            block
            onClick={handleCancelStop}
            loading={loading}>
            Cancel Stop Request
          </Button>
        )}
        {!canApprove && !isOwner && (
          <Text type="secondary" italic>
            You can only view this stop request.
          </Text>
        )}
      </Space>
    </Modal>
  )
}
